import React, { useState } from "react"
import { Container, Form} from "reactstrap"
import { useFormik } from "formik"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import { ROOM_REQUIRED_FIELDS } from "./CONSTANT"
import * as Yup from "yup"
import RoomForm from "./RoomForm"
import { editRoom, getRoom } from "../../../../api/rooms"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

ROOM_REQUIRED_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] || "";
    
    if (f.type == "file") {
        FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
            "This Field Is Required"
        );
    } else if (f.type == "select" && f.isMulti) {
        FIELDS_VALIDATION[f.key] = Yup.array();
    } else {
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
    }
});

const EditRoom = () => {
    let navigate = useHistory()
    const { t } = useTranslation()
    const {id: roomId} = useParams()
    const [editedRoom, setEditedRoom] = useState(null)
    const [houseId, sethouseId] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getRoom,
        roomId,
        response => {
            setEditedRoom({
                ...response.data.room,
                picture_preview: response.data.room.picture,
                picture: null,
            })
            sethouseId(response.data.room.housing.id)
        }
    )

    const { setData, loading, error, success } = useResponse(editRoom, () => {
        navigate.goBack()
    })
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...editedRoom,
            number: +houseId // house number for
        },
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: (values) => {
            let data = new FormData()

            Object.keys(values).map(key => {
                if(values[key]){
                    data.append(key, values[key])
                }
            })

            setData({ type: "edit", id: roomId, data })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Rooms")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Room")}
                    />
                    
                        {editedRoom && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <RoomForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditRoom